import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Nav.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var Nav = function Nav(_ref) {
  var dresses = _ref.dresses,
      index = _ref.index,
      _onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("div", {
    className: cc([css.root, _defineProperty({}, css.on, index > -1 && index < dresses.length)]),
    children: dresses.map(function (dress, idx) {
      return /*#__PURE__*/_jsx("button", {
        "aria-label": "Click to scroll to ".concat(dress.name),
        className: cc([css.button, _defineProperty({}, css.on, index === idx)]),
        onClick: function onClick() {
          _onClick(idx);
        },
        type: "button",
        children: /*#__PURE__*/_jsx("div", {
          className: css.label,
          children: dress.name
        })
      }, "nav-".concat(dress.name));
    })
  });
};

Nav.propTypes = {
  dresses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
};
export default Nav;